import type { NskResponse } from "~/models/Api";
import { generatePath } from "~/utils/generatePath";
import { putRequest } from "../api_handler";

export const update = async (dealId: number): Promise<NskResponse> =>
	putRequest(
		generatePath("/deals/:deal_id/revert_own_status", { deal_id: dealId })
	);
